(function () {
  'use strict';

  // ===== Configuration =====
  var SEND_OTP_URL   = 'https://admin.rightgifting.com/webhook/send-otp';
  var VERIFY_OTP_URL = 'https://admin.rightgifting.com/webhook/verify-otp';
  var COUNTDOWN_SECONDS = 60;
  var REDIRECT_URL   = '/pages/my-account';
  var DEBUG          = true; // flip to false in production

  function log() {
    if (DEBUG && window.console) console.log.apply(console, ['[RG-OTP]'].concat([].slice.call(arguments)));
  }

  // Wait for DOM — works whether script loads with `defer` or not
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function init() {
    log('init');

    // If already logged in, skip login page — go straight to account
    var existingToken = document.cookie.match(/wa_customer_token=([^;]+)/);
    if (existingToken && existingToken[1]) {
      log('already logged in, redirecting to account');
      window.location.href = REDIRECT_URL;
      return;
    }

    // ===== State =====
    var currentPhone   = '';
    var countdownTimer = null;

    // ===== DOM references =====
    var phoneStep     = document.getElementById('rg-phone-step');
    var otpStep       = document.getElementById('rg-otp-step');
    var successStep   = document.getElementById('rg-success-step');

    var phoneInput    = document.getElementById('rg-phone');
    var phoneError    = document.getElementById('rg-phone-error');
    var sendBtn       = document.getElementById('rg-send-btn');

    var otpBoxesWrap  = document.getElementById('rg-otp-boxes');
    var otpBoxes      = otpBoxesWrap
                          ? [].slice.call(otpBoxesWrap.querySelectorAll('.rg-otp__box'))
                          : [];
    var otpError      = document.getElementById('rg-otp-error');
    var verifyBtn     = document.getElementById('rg-verify-btn');

    var displayPhone  = document.getElementById('rg-display-phone');
    var changePhone   = document.getElementById('rg-change-phone');
    var countdownEl   = document.getElementById('rg-countdown');
    var timerText     = document.getElementById('rg-timer-text');
    var resendBtn     = document.getElementById('rg-resend-btn');

    // Bail gracefully if section isn't on page
    if (!phoneStep || !otpStep || !successStep) {
      log('section not present on page — aborting');
      return;
    }

    if (!sendBtn) { log('ERROR: rg-send-btn not found'); return; }
    if (!phoneInput) { log('ERROR: rg-phone not found'); return; }
    if (!verifyBtn) { log('ERROR: rg-verify-btn not found'); return; }

    log('elements found, wiring up', { sendBtn: sendBtn, phoneInput: phoneInput, otpBoxes: otpBoxes.length });

    // Cache ORIGINAL button HTML so we can restore it (don't overwrite with textContent)
    var sendBtnOriginalHTML   = sendBtn.innerHTML;
    var verifyBtnOriginalHTML = verifyBtn.innerHTML;

    // ===== Step navigation =====
    function showStep(step) {
      log('showStep', step);
      phoneStep.hidden   = step !== 'phone';
      otpStep.hidden     = step !== 'otp';
      successStep.hidden = step !== 'success';
    }

    // ===== Error helpers =====
    function showError(el, msg) {
      if (!el) return;
      el.textContent = msg;
      el.hidden = false;
      el.removeAttribute('hidden'); // belt-and-suspenders
      el.style.display = '';
    }
    function hideError(el) {
      if (!el) return;
      el.textContent = '';
      el.hidden = true;
    }

    // ===== Phone input: digits only, max 10 =====
    phoneInput.addEventListener('input', function () {
      this.value = this.value.replace(/[^0-9]/g, '').slice(0, 10);
      hideError(phoneError);
    });
    phoneInput.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.keyCode === 13) {
        e.preventDefault();
        handleSendOtp();
      }
    });

    // ===== SEND OTP handler (extracted so we can call from Enter too) =====
    async function handleSendOtp() {
      log('handleSendOtp fired');
      var phone = (phoneInput.value || '').trim();

      if (phone.length !== 10) {
        showError(phoneError, 'Please enter a valid 10-digit mobile number.');
        phoneInput.focus();
        return;
      }

      sendBtn.disabled = true;
      sendBtn.innerHTML = '<span class="rg-cta__label">Sending…</span>';
      hideError(phoneError);

      try {
        log('sending OTP to', '+91' + phone);
        var res = await fetch(SEND_OTP_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ phone: '+91' + phone })
        });
        var data = await res.json();
        log('send response', res.status, data);

        if (!res.ok || !data.success) {
          throw new Error(data.message || 'Failed to send OTP. Please try again.');
        }

        currentPhone = '+91' + phone;
        if (displayPhone) displayPhone.textContent = '+91 ' + phone;

        showStep('otp');
        clearOtpBoxes();
        syncVerifyButton();
        if (otpBoxes[0]) otpBoxes[0].focus();
        startCountdown();

      } catch (err) {
        log('send error', err);
        showError(phoneError, err.message || 'Could not send OTP. Please try again.');
      } finally {
        sendBtn.disabled = false;
        sendBtn.innerHTML = sendBtnOriginalHTML;
      }
    }

    // ===== Wire up Send button — multiple listeners for robustness =====
    sendBtn.addEventListener('click', function (e) {
      log('sendBtn click received', e.target);
      e.preventDefault();
      e.stopPropagation();
      handleSendOtp();
    });

    // ===== OTP box utilities =====
    function getOtpValue() {
      return otpBoxes.map(function (b) { return b.value; }).join('');
    }
    function clearOtpBoxes() {
      otpBoxes.forEach(function (b) {
        b.value = '';
        b.classList.remove('rg-filled');
        b.classList.remove('rg-err');
      });
    }
    function shakeOtpBoxes() {
      otpBoxes.forEach(function (b) { b.classList.add('rg-err'); });
      setTimeout(function () {
        otpBoxes.forEach(function (b) { b.classList.remove('rg-err'); });
      }, 500);
    }
    function syncVerifyButton() {
      verifyBtn.disabled = getOtpValue().length !== 6;
    }

    // ===== OTP box behaviors =====
    otpBoxes.forEach(function (box, idx) {
      box.addEventListener('input', function () {
        var v = this.value.replace(/[^0-9]/g, '');
        this.value = v.slice(-1);

        if (this.value) {
          this.classList.add('rg-filled');
          this.classList.remove('rg-err');
          if (idx < otpBoxes.length - 1) otpBoxes[idx + 1].focus();
          else this.blur();
        } else {
          this.classList.remove('rg-filled');
        }

        hideError(otpError);
        syncVerifyButton();

        if (getOtpValue().length === 6 && !verifyBtn.disabled) {
          handleVerifyOtp();
        }
      });

      box.addEventListener('keydown', function (e) {
        if (e.key === 'Backspace') {
          if (!this.value && idx > 0) {
            var prev = otpBoxes[idx - 1];
            prev.value = '';
            prev.classList.remove('rg-filled');
            prev.focus();
            e.preventDefault();
            syncVerifyButton();
          }
        } else if (e.key === 'ArrowLeft' && idx > 0) {
          otpBoxes[idx - 1].focus();
          e.preventDefault();
        } else if (e.key === 'ArrowRight' && idx < otpBoxes.length - 1) {
          otpBoxes[idx + 1].focus();
          e.preventDefault();
        } else if (e.key === 'Enter') {
          if (!verifyBtn.disabled) handleVerifyOtp();
          e.preventDefault();
        }
      });

      box.addEventListener('paste', function (e) {
        e.preventDefault();
        var text = (e.clipboardData || window.clipboardData).getData('text') || '';
        var digits = text.replace(/[^0-9]/g, '').slice(0, 6);
        if (!digits) return;

        for (var i = 0; i < otpBoxes.length; i++) {
          if (i < digits.length) {
            otpBoxes[i].value = digits[i];
            otpBoxes[i].classList.add('rg-filled');
            otpBoxes[i].classList.remove('rg-err');
          } else {
            otpBoxes[i].value = '';
            otpBoxes[i].classList.remove('rg-filled');
          }
        }
        var focusIdx = Math.min(digits.length, otpBoxes.length - 1);
        otpBoxes[focusIdx].focus();
        hideError(otpError);
        syncVerifyButton();
        if (digits.length === 6 && !verifyBtn.disabled) handleVerifyOtp();
      });

      box.addEventListener('focus', function () {
        var self = this;
        setTimeout(function () { self.select(); }, 0);
      });
    });

    // ===== VERIFY OTP handler =====
    async function handleVerifyOtp() {
      log('handleVerifyOtp fired');
      var otp = getOtpValue();

      if (otp.length !== 6) {
        showError(otpError, 'Please enter the full 6-digit code.');
        return;
      }

      verifyBtn.disabled = true;
      verifyBtn.innerHTML = '<span class="rg-cta__label">Verifying…</span>';
      hideError(otpError);

      try {
        var res = await fetch(VERIFY_OTP_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ phone: currentPhone, otp: otp })
        });
        var data = await res.json();
        log('verify response', res.status, data);

        if (!res.ok || !data.success) {
          var msg = data.message || 'Invalid OTP. Please try again.';
          if (msg.indexOf('EXPIRED') !== -1) throw new Error('OTP has expired. Please request a new one.');
          if (msg.indexOf('INVALID') !== -1) throw new Error('Incorrect OTP. Please check and try again.');
          throw new Error(msg);
        }

        // Success — validate response fields
        if (!data.accessToken) {
          throw new Error('Server did not return an access token. Please try again.');
        }

        clearInterval(countdownTimer);

        // Parse expiry safely — fall back to 30 days if server value is missing/invalid
        var expiryDate = data.expiresAt ? new Date(data.expiresAt) : null;
        if (!expiryDate || isNaN(expiryDate.getTime())) {
          log('WARNING: invalid or missing expiresAt, using 30-day fallback. Got:', data.expiresAt);
          expiryDate = new Date(Date.now() + 30 * 24 * 60 * 60 * 1000);
        }
        var expires = expiryDate.toUTCString();
        log('setting cookies with expiry:', expires);
        log('accessToken length:', data.accessToken.length);

        // Detect insecure context and drop the `secure` flag if needed
        // (cookies with `secure` are silently rejected on http://)
        var isSecure = window.location.protocol === 'https:';
        var secureFlag = isSecure ? '; secure' : '';

        var tokenCookie = 'wa_customer_token=' + data.accessToken +
                          '; path=/; expires=' + expires + secureFlag + '; samesite=lax';
        document.cookie = tokenCookie;

        var emailCookie = 'wa_customer_email=' + encodeURIComponent(data.email || '') +
                          '; path=/; expires=' + expires + '; samesite=lax';
        document.cookie = emailCookie;

        // Verify the cookie actually landed before redirecting
        var tokenCheck = document.cookie.match(/wa_customer_token=([^;]+)/);
        if (!tokenCheck) {
          log('ERROR: cookie failed to persist. document.cookie =', document.cookie);
          throw new Error('Could not save login. Please check your browser cookie settings and try again.');
        }
        log('cookie saved successfully, redirecting in 1.2s');

        showStep('success');
        setTimeout(function () { window.location.href = REDIRECT_URL; }, 1200);

      } catch (err) {
        log('verify error', err);
        showError(otpError, err.message || 'Verification failed. Please try again.');
        shakeOtpBoxes();
        verifyBtn.disabled = false;
        verifyBtn.innerHTML = verifyBtnOriginalHTML;
        if (otpBoxes.length) otpBoxes[otpBoxes.length - 1].focus();
      }
    }

    verifyBtn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      handleVerifyOtp();
    });

    // ===== CHANGE NUMBER =====
    if (changePhone) {
      changePhone.addEventListener('click', function (e) {
        e.preventDefault();
        clearInterval(countdownTimer);
        clearOtpBoxes();
        hideError(otpError);
        hideError(phoneError);
        verifyBtn.disabled = true;
        showStep('phone');
        setTimeout(function () { phoneInput.focus(); }, 50);
      });
    }

    // ===== RESEND OTP =====
    if (resendBtn) {
      resendBtn.addEventListener('click', async function (e) {
        e.preventDefault();
        resendBtn.hidden = true;
        if (timerText) timerText.hidden = false;
        hideError(otpError);
        clearOtpBoxes();
        syncVerifyButton();
        if (otpBoxes[0]) otpBoxes[0].focus();

        try {
          var res = await fetch(SEND_OTP_URL, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ phone: currentPhone })
          });
          var data = await res.json();
          if (data.success) {
            startCountdown();
          } else {
            showError(otpError, data.message || 'Could not resend OTP. Please try again.');
            resendBtn.hidden = false;
            if (timerText) timerText.hidden = true;
          }
        } catch (err) {
          showError(otpError, 'Could not resend OTP. Please try again.');
          resendBtn.hidden = false;
          if (timerText) timerText.hidden = true;
        }
      });
    }

    // ===== COUNTDOWN =====
    function startCountdown() {
      if (!countdownEl || !timerText || !resendBtn) return;
      var seconds = COUNTDOWN_SECONDS;
      countdownEl.textContent = seconds;
      timerText.hidden = false;
      resendBtn.hidden = true;

      clearInterval(countdownTimer);
      countdownTimer = setInterval(function () {
        seconds--;
        countdownEl.textContent = seconds;
        if (seconds <= 0) {
          clearInterval(countdownTimer);
          timerText.hidden = true;
          resendBtn.hidden = false;
        }
      }, 1000);
    }

    log('wiring complete');
  }
})();
